<template>
  <div class="wrapper">
    <Loader v-if="loading"/>
    <parallax
      class="section page-header header-filter"
      :style="{ backgroundImage: 'url(' + header_pictures.products_header_picture.url + ')' }"
    ></parallax>
    <div class="main main-raised">
      <div class="section profile-content">
        <Loader v-if="productsloading"/>
        <div class="product-page" v-else>
          <div class="navigation-breadcrumbs">
            <router-link to="/">
                <h5> Asiongs</h5>
            </router-link>
            <h5> ></h5>
            <router-link to="/products">
                <h5>Products</h5>
            </router-link>
            <h5> > </h5>
            <h5>{{product.Name}}</h5>
          </div>
            
          <div class="product-specs-container">
            <div class="product-specs-top">
              <div class="product-pictures">
                <div class="expanded-picture">
                  <img :src=expanded_pic alt="">
                </div>
                <div  class="more-pictures" v-if="more_pics">
                  <img :src=product.main_picture.url class="more-picture" v-on:click="expandPic(product.main_picture.url)" >
                  <div class="more-picture" v-for="picture in product.pictures" :key="picture.id">
                    <img :src=picture.url v-on:click="expandPic(picture.url)">
                  </div>
                </div>

                
              </div>

              <div class="product-spec-smalltexts">
                <h3>{{product.Name}}</h3>
                <div class="categories-container">
                  <div v-for="categoryitem in product.categories" :key="categoryitem.id" >
                    <router-link :to="'/products/' + categoryitem.slug">
                      <div class="category-item">
                        <h5>{{categoryitem.Name}}</h5>
                      </div>
                    </router-link>
                  </div>
                </div>
                <div>
                  <div class="product-applications-container">
                    <div v-for="application in product.product_applications" :key="application.id" class="badge badge-primary">
                      {{application.name}}
                    </div>
                  </div>
                </div>
                <vue-simple-markdown :source=product.product_specs_description></vue-simple-markdown>
                <table>
                  <tr v-if="product.brand">
                    <td><strong>Brand:</strong> </td>
                    <td>{{product.brand.Name}}</td>
                  </tr>
                  <tr v-if="product.colors">
                    <td><strong>Colors:</strong> </td>
                    <td>{{product.colors}}</td>
                  </tr>
                  <tr v-if="product.sizes">
                    <td><strong>Sizes:</strong> </td>
                    <td>{{product.sizes}}</td>
                  </tr>
                </table>
                
                <div class="quotation-form">
                  <div v-if="success" class="alert alert-success">
                    Great! Your message has been sent successfully. We will try to respond quickly.
                  </div>
                  <form 
                  v-else
                  v-on:submit.prevent="sendQuoteRequest"
                  class="contact-form"
                  >
                    <div v-if="errored" class="alert alert-danger">
                      Bummer, Something went wrong. Did you fill out all of the fields?
                    </div>
                    <h5>Interested in this product? Request for quotation below!</h5>
                    <div class="">
                      <md-field class="">
                        <label>Your Email</label>
                        <md-input v-model="form.email" type="email" required ></md-input>
                      </md-field>
                    </div>
                    <md-button class="md-success" type="submit">{{ loading ? "Sending Message..." : "Submit" }}</md-button>
                    
                  </form>
                </div>
                
              </div>
            </div>
          </div>
          <div class="product-page-buttom">
            <div v-if="product.more_details" class="more-product-details">
              <h5>More product details of {{product.Name}}</h5>
              <vue-simple-markdown :source=product.more_details></vue-simple-markdown>
            </div>
            <div class="related-products">
              <h4>Related Products: </h4>
                <Featuredproducts 
                  :products=queriedRelatedProducts
                  :page=RelatedProductsPagination
                >
                </Featuredproducts>
                <pagination
                  v-if="relatedProductsPageCount != 1"
                  class=""
                  v-model="RelatedProductsPagination"
                  with-text
                  :page-count=relatedProductsPageCount
                  v-on:click.native="queryRelatedProducts"
                >
                </pagination>
            </div>
          </div>
          
          
          
          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { Pagination } from "@/components";
import Loader from "@/components/Loader.vue";
import Featuredproducts from "@/components/Featuredproducts.vue";

export default {

  components: {
    Loader,
    Featuredproducts,
    Pagination
  },
  bodyClass: "profile-page",
  data() {
    return {
      produrl: this.$route.params.prodid,
      prodid: 0,
      product: {
        main_picture: {
          url: ''
        }
      },
      prod_array: [],
      // loading: true,
      loading: false,
      success: false,
      errored: false,
      more_pics: false,
      expanded_pic: "",
      form: {
        email: ""
      },
      queryRelated: "",
      relatedProducts: [],
      RelatedProductsPagination: 1,
      relatedProductsPageCount: 1,
      limit: 8,
      queryRelatedLimiter: "",
      relatedProductsCount: 0,
      queriedRelatedProducts: [],
      productsloading: true,
    };
  },
  created() {
    // console.log(this.$route.params.prodid) // prints value of :prodid
    
  },
  props: {
    header_pictures: Object
  },
  methods: {
    sendQuoteRequest(){
      axios.post("https://strapi-asiongs.herokuapp.com/quotation-requests", {
        email: this.form.email,
        product: ("I am interested in " + this.product.Name + " from " + this.product.brand.Name )
      }).then((res) => {
        //Perform Success Action
        this.success = true;
        this.errored =false;
        // console.log("form success");
      }).catch((error) => {
        // error.response.status Check status code
        this.errored = true
        // console.log("form error");
      }).finally(() => {
        //Perform action in always
        this.loading = false
      });
    },
    // For file download   
    // downloadItem ({ url, label }) {
    //     Axios.get(url, { responseType: 'blob' })
    //     .then(response => {
    //         const blob = new Blob([response.data], { type: 'application/pdf' })
    //         const link = document.createElement('a')
    //         link.href = URL.createObjectURL(blob)
    //         link.download = label
    //         link.click()
    //         URL.revokeObjectURL(link.href)
    //     }).catch(console.error)
    // }
    getrelatedProducts(){
      axios.get(("https://strapi-asiongs.herokuapp.com/products?id_ne="+ this.prodid + "&" + this.queryRelated), {}).then(
        (response) => {
          this.relatedProducts = response.data;
          this.relatedProductsPageCount = Math.ceil(this.relatedProducts.length / 8);
        },
        (error) => {
          // console.log(error);
        }
      );
    },
    queryRelatedProducts(){
      this.limit = (this.RelatedProductsPagination * 8);
      this.queryRelatedLimiter = ("_start=" + (this.limit - 8) + "&_limit=8");
      axios.get(("https://strapi-asiongs.herokuapp.com/products?id_ne="+ this.prodid + "&" + this.queryRelated + this.queryRelatedLimiter), {}).then(
        (response) => {
          this.queriedRelatedProducts = response.data;
        },
        (error) => {
          // console.log(error);
        }
      );
    },
    expandPic(pictureurl) {
      this.expanded_pic = pictureurl;
      // console.log(pictureurl)
    }
  },
  mounted() {
    axios.get(("https://strapi-asiongs.herokuapp.com/products?slug=" + this.produrl), {}).then(
      (response) => {
        this.prod_array = response.data;
        this.product = this.prod_array[0];
        this.prodid = this.product.id;
        // console.log(this.product);
        this.expanded_pic = this.product.main_picture.url;
        this.loading = false;
        if (this.product.pictures.length !== 0) {
          this.more_pics = true;
        }
        this.product.categories.forEach(function (prodcategory) {
          this.queryRelated += ("categories="+prodcategory.id+"&");
        }, this);
        this.getrelatedProducts();
        this.queryRelatedProducts();
        this.productsloading = false;
      },
      (error) => {
        // console.log(error);
      }
    );
    
    
  },
  computed: {
    // headerStyle() {
    //   return {
    //     backgroundImage: `url(${this.header})`
    //   };
    // }
  },
  
  metaInfo(){
    return {
      title: `${this.product.Name} - Asiongs Industrial Products`,
      meta: [
          { name: 'description', content: 'Learn more about ' + this.product.Name + ' on Asiongs Industrial Products'},
          { property: 'og:title', content: this.product.Name + ' - Asiongs Industrial Products'},
          { property: 'og:site_name', content: 'Asiongs Industrial Products'},
          { property: 'og:description', content:  "Asiong's Industrial Products is an importer and distributor for general safety equipment. We provide an extensive range of industrial products and Personal Protective Equipment (PPE)."},
          { property: 'og:site_name', content: 'Asiongs Industrial Products'},
          { property: 'og:type', content: 'website'},    
          { property: 'og:image', content: this.product.main_picture.url}
      ]
    }
  }

};
</script>

<style lang="scss" scoped>
.section {
  padding: 0;
}

.profile-tabs::v-deep {
  .md-card-tabs .md-list {
    justify-content: center;
  }

  [class*="tab-pane-"] {
    margin-top: 3.213rem;
    padding-bottom: 50px;

    img {
      margin-bottom: 2.142rem;
    }
  }
}

.product-page{
  padding: 24px;
  max-width: 1200px;
  margin: 48px auto;
  .navigation-breadcrumbs{
    display: flex;
    flex-flow: row wrap;
    margin-bottom: 24px;
    
    h5{
      margin: 0px 4px;
    }

  }
}

.product-specs-container{
  // 
  .product-specs-top{
    display: grid;
    // grid-template-columns: repeat(auto-fit, minmax(320px , 1fr));
    gap: 32px;
  }

  @media only screen and (min-width: 600px) {
        .product-specs-top{
            grid-template-columns: repeat(auto-fit, minmax(320px , 1fr));
        }
    }

    @media only screen and (max-width: 559px) {
        .product-specs-top{
            grid-template-columns: repeat(auto-fit, minmax(220px , 1fr));
        }
    }
  
  // box-shadow: 0 10px 30px -16px rgb(0 0 0 / 24%), 0 16px 20px -10px rgb(0 0 0 / 20%);

  .product-pictures{

    .expanded-picture{
      width: 100%;
      margin-bottom: 16px;
      border: 2px solid #eeeeee;
      padding-top: 100%;
      position: relative;
      // border-radius: 16px;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        position: absolute;
        top: 0
      }
    }

    .main-picture{
      // height: 400px;
      width: 100%;
      padding-top: 100%;

      img{
        height: 100%;
        width: 100%;
        object-fit: cover;
      }
    }

    .more-pictures{
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(72px , 80px));
      grid-auto-rows: 1fr;
      gap: 16px;
      margin-bottom: 16px;
      
      .more-picture{
        width: 100%;
        height: 100%;
      }
      img{
        width: 100%;
        max-height: 80px;
        height: 100%;
        object-fit: cover;
        border: 2px solid #EEEEEE;
        
        transition: 0.1s;

        &:hover{
          cursor: pointer;
          border: 4px solid #1a237e;
        }
      }
    }
  }

  .quotation-form{
    // background: #1a237e;
    padding: 16px;
    // color: white;
    // border-radius: 8px;
    border-top: 2px solid #eeeeee;
  }

  .product-spec-smalltexts{
    h2{
      margin: 0;
    }

    .categories-container{
      margin: 16px 0px;
      display: flex;
      flex-flow: row wrap;

      .category-item{
        border: 1px solid #eeeeee;
        padding: 4px;
        margin-right: 4px;
        margin-bottom: 4px;
        border-radius: 4px;
        transition: 0.3s;

        &:hover{
          border-color: #1a237e;
        }
        
        h5{
          margin: 0;
          color: #1a237e;
        }
      }
    }

    table{
      // border-top: 2px solid #eeeeee;
      width: 100%;
      padding: 8px;
      border-collapse: separate;
      margin: 16px 0px;
    }

    .product-applications-container{
      margin: 8px 0px;
      display: flex;
      flex-flow: row wrap;
      
      .badge{
        margin-bottom: 5px;
      }
    }
    
  }
}

.product-page-buttom{
  // display: grid;
  // grid-template-columns: 3fr 1fr;
  // gap: 16px;
  margin: 16px 0px;

  .more-product-details{
    border-top: 2px solid #eeeeee;
    border-bottom: 2px solid #eeeeee;
    padding: 16px;
  }

  .related-products{
    margin: 16px 0px;
  }
}




</style>
